/* global axios */
import ApiClient from './ApiClient';

class WhatsappCampaignsAPI extends ApiClient {
  constructor() {
    super('whatsapp_campaigns', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  schedule(id, scheduledAt) {
    return axios.post(`${this.url}/${id}/schedule`, {
      scheduled_at: scheduledAt,
    });
  }

  start(id) {
    return axios.post(`${this.url}/${id}/start`);
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  getRecipients(id, params = {}) {
    return axios.get(`${this.url}/${id}/recipients`, { params });
  }

  importRecipients(id, payload) {
    return axios.post(`${this.url}/${id}/import`, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  recipientsFromInbox(id, payload) {
    return axios.post(`${this.url}/${id}/recipients_from_inbox`, payload);
  }

  recipientsFromFilters(id, payload) {
    return axios.post(`${this.url}/${id}/recipients_from_filters`, payload);
  }

  recipientsFromPipelineStage(id, payload) {
    return axios.post(
      `${this.url}/${id}/recipients_from_pipeline_stage`,
      payload
    );
  }

  recipientsFromConversions(id, payload) {
    return axios.post(`${this.url}/${id}/recipients_from_conversions`, payload);
  }

  getMetrics(id) {
    return axios.get(`${this.url}/${id}/metrics`);
  }

  getSummary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }

  getEvents(id, params = {}) {
    return axios.get(`${this.url}/${id}/events`, { params });
  }

  clone(id) {
    return axios.post(`${this.url}/${id}/clone`);
  }

  exportCsv(id) {
    return axios.get(`${this.url}/${id}/export`, { responseType: 'blob' });
  }

  inboxConnection(inboxId) {
    return axios.get(
      `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_cloud_connection`
    );
  }

  saveInboxConnection(inboxId, connection) {
    return axios.post(
      `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_cloud_connection`,
      {
        connection,
      }
    );
  }

  deleteInboxConnection(inboxId) {
    return axios.delete(
      `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_cloud_connection`
    );
  }

  getTemplates(inboxId, params = {}) {
    return axios.get(
      `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_templates`,
      {
        params,
      }
    );
  }

  syncTemplates(inboxId) {
    return axios.post(
      `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_templates/sync`
    );
  }

  previewTemplate(inboxId, templateId, payload) {
    return axios.post(
      `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_templates/${templateId}/preview`,
      payload
    );
  }

  createTemplate(inboxId, payload) {
    return axios.post(
      `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_templates`,
      payload
    );
  }

  deleteTemplate(inboxId, templateId) {
    return axios.delete(
      `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_templates/${templateId}`
    );
  }

  uploadTemplateMedia(inboxId, formData) {
    return axios.post(
      `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_templates/upload_media`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  uploadCampaignVariableMedia(inboxId, formData) {
    return axios.post(
      `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_templates/upload_campaign_media`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  getAudienceFields(inboxId) {
    return axios.get(
      `${this.baseUrl()}/inboxes/${inboxId}/whatsapp_audience_fields`
    );
  }
}

export default new WhatsappCampaignsAPI();
